import React from "react";
import Layout from "../Shared/Layout";
import {Container, Grid, Paper} from "@material-ui/core";
import styled from "styled-components";
import {InertiaLink} from "@inertiajs/inertia-react";
import AccordionList from "../Shared/AccordionList";
import {Trans} from "../utils/i18n";

const BoxImg = styled.img`
    width: 140px;
    height: 140px;
    margin: auto;
    object-fit: contain;
`;

export default function HomeSegway({languages, currentLanguage, faqs, client}) {
    return (
        <div className={"-mt-12 bgcolor"}>
            <div
                className={`w-full bg-pattern bg-top lg:bg-center bg-no-repeat bg-contain p-2 py-16 lg:min-h-[400px] md:min-h-[300px] min-h-[200px]`}
                style={{backgroundImage: `url(${client.home_banner})`}}
            >
            </div>
            <Container maxWidth="lg">
                <div className={"max-w-xl mx-auto"}>
                    <h2 className={"text-center text-5xl font-bold mb-0"}>
                        {client?.name}
                        &nbsp;
                        <Trans i18nKey={"welcome.serviceSolutions"}>
                            Service Solutions
                        </Trans>
                    </h2>
                </div>
                <div className={"relative"}>
                    <div
                        className={
                            "mx-auto mt-20 grid grid-cols-12 gap-6 lg:gap-16 w-full justify-between max-w-4xl"
                        }
                    >
                        <div
                            className={
                                "col-span-12 md:col-span-4 flex justify-center box"
                            }
                        >
                            <div
                                className={
                                    "flex flex-col items-center rounded-2xl  w-full max-w-[264px]"
                                }
                            >
                                <BoxImg
                                    src={"/images/segway/warranty_check.svg"}
                                    className={""}
                                />
                                <div
                                    className={
                                        "p-3 text-center flex flex-col items-center flex-1"
                                    }
                                >
                                    <InertiaLink
                                        href={route('warranty.index')}
                                        className={
                                            "no-underline block font-bold bg-[#232323] rounded-md text-white px-9 py-3  hover:bg-white hover:text-[#232323] shadow-lg shadow"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "welcome.serviceSolutions.warrantyCheck"
                                            }
                                        >
                                            Warranty Check
                                        </Trans>
                                    </InertiaLink>
                                    <p
                                        className={
                                            "font-regular flex-1 mt-4"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "welcome.serviceSolutions.warrantyCheck.description"
                                            }
                                        >
                                            Check the warranty status of your device
                                        </Trans>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div
                            className={
                                "col-span-12 md:col-span-4 flex justify-center"
                            }
                        >
                            <div
                                className={
                                    "flex flex-col items-center rounded-2xl  w-full max-w-[264px] box"
                                }
                            >
                                <BoxImg
                                    src={"/images/segway/request_repair.svg"}
                                    className={""}
                                />
                                <div
                                    className={
                                        "p-3 text-center flex flex-col items-center flex-1"
                                    }
                                >
                                    <InertiaLink
                                        href={route('order')}
                                        className={
                                            "no-underline block font-bold bg-[#232323] rounded-md text-white px-9 py-3  hover:bg-white hover:text-[#232323] shadow-lg shadow"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "welcome.serviceSolutions.request_a_repair"
                                            }
                                        >
                                            Request a repair
                                        </Trans>
                                    </InertiaLink>
                                    <div
                                        className={
                                            "font-regular flex-1 mt-4"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "welcome.serviceSolutions.selfService.description"
                                            }
                                        >
                                            Create Service Requests
                                        </Trans>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className={
                                "col-span-12 md:col-span-4 flex justify-center"
                            }
                        >
                            <div
                                className={
                                    "flex flex-col items-center rounded-2xl  w-full max-w-[264px] box"
                                }
                            >
                                <BoxImg
                                    src={"/images/segway/track.svg"}
                                    className={""}
                                />
                                <div
                                    className={
                                        "p-3 text-center flex flex-col items-center flex-1"
                                    }
                                >
                                    <InertiaLink
                                        href={route('track.index')}
                                        className={
                                            "no-underline block font-bold bg-[#232323] rounded-md text-white px-9 py-3  hover:bg-white hover:text-[#232323] shadow-lg shadow"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "dashboard.trackTrace"
                                            }
                                        >
                                            Track & Trace
                                        </Trans>
                                    </InertiaLink>
                                    <p
                                        className={
                                            "font-regular flex-1 mt-4"
                                        }
                                    >
                                        <Trans
                                            i18nKey={
                                                "dashboard.trackTrace.description"
                                            }
                                        >
                                            Track your service event and get the latest status
                                        </Trans>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {faqs.length > 0 && (
                    <div className="max-w-4xl mx-auto flex flex-col items-center mt-32 mb-16 rounded  shadow-lg bg-[#fff] p-4">
                        <>
                            <h2
                                className={
                                    "text-center text-2xl font-bold mb-0 mt-8"
                                }
                            >
                                <Trans i18nKey={"welcome.faq.title"}>
                                    FAQs & Troubleshooting Guides
                                </Trans>
                            </h2>
                            <p
                                className={
                                    "text-center text-md font-medium mt-4"
                                }
                            >
                                <Trans i18nKey={"welcome.faq.subtitle"}>
                                    All you need to know about our service offer
                                </Trans>
                            </p>
                            <div className="w-11/12">
                                <AccordionList items={faqs}/>
                            </div>
                        </>
                        <p className={"text-center mt-3 mb-8 pt-8"}>
                            <InertiaLink
                                className={" block font-bold text-secondary"}
                                href={route("faq")}
                            >
                                <Trans i18nKey={"welcome.checkAllResources"}>Check all the resources</Trans>
                            </InertiaLink>
                        </p>
                    </div>
                )}

                {
                    <div
                        className="max-w-4xl mx-auto flex flex-col items-center mt-32 mb-16 rounded  shadow-lg bg-[#fff] p-4">
                        <h2
                            className={
                                "text-center text-2xl font-bold mb-0 mt-8"
                            }
                        >
                            <Trans i18nKey={"welcome.whitelabel.need_help"}>
                                Need help?
                            </Trans>
                        </h2>
                        <p className={"text-center text-md font-medium mt-4"}>
                            <Trans i18nKey={"welcome.whitelabel.need_help_descrption"}>
                                For further assistance please feel free to chat with us.
                            </Trans>
                        </p>
                        <p className={"text-center mt-3 mb-8"}>
                            <InertiaLink
                                className={
                                    "no-underline block font-bold bg-[#232323] rounded-md text-white px-9 py-3  hover:bg-white hover:text-[#232323] shadow-lg shadow"
                                }
                                href={route("contact")}
                            >
                                <Trans i18nKey={"welcome.checkResources"}>
                                    Check resources
                                </Trans>
                            </InertiaLink>
                        </p>

                        <div className="flex flex-col md:flex-row gap-12 justify-center">
                            {[
                                {
                                    email: "support-EU@segway.eu.com",
                                    hours: "9:00 AM to 5:30 PM (CET), Monday till Friday.",
                                    phone: "+31 202140274",
                                    // text: <Trans i18nKey=".english">English</Trans>,
                                    text: "Segway Call Center",
                                    code: "en",
                                },
                            ]?.map((language, index) => {
                                return (
                                    <div className="text-center" key={language.code}>
                                        <h2 className="text-lg font-semibold">
                                            {language.text}
                                        </h2>
                                        <p className="text-gray-700">{language.phone}</p>
                                        <p className="text-gray-700">{language.hours}</p>
                                        <a
                                            href={`mailto:${language.email}`}
                                            className="text-gray-700 no-underline"
                                        >
                                            {language.email}
                                        </a>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                }
            </Container>
        </div>
    );
}

HomeSegway.layout = (page) => <Layout children={page}/>;
